import React, { useState, useEffect } from "react";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line } from "recharts";
import {
  Container,
  PageHeader,
  FilterRow,
  AdvancedFiltersContainer,
  FilterToggle,
  FilterGroup,
  FilterLabel,
  TableWrapper,
  AddButton,
  ModalOverlay,
  ModalContent,
  ModalTitle,
  Input,
  TextArea,
  Select,
  ModalActions,
  ButtonCancelar,
  ButtonSalvar,
  StatusBadge,
  DashboardCard,
  DashboardCardTitle,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  ActionButton,
  RecomendationsContainer,
  RecomendationsTitle,
  RecomendationsList,
  ActionPanel,
  ExportButton,
  BatchActionButton,
  ViewToggleButton,
  SummaryCard,
  SummaryLabel,
  SummaryValue,
  SummaryCardsContainer,
  NextPaymentsContainer,
  SectionTitle,
  NextPaymentsList,
  NextPaymentCard,
  DashboardGrid,
  EmptyState,
  TabsContainer,
  Tab,
  AttachmentArea,
  AttachmentItem,
  TabContent,
  CustomTooltip,
  TagsContainer,
  Tag,
  TagInput,
  AnimatedCard,
  FileUploadArea,
  CommunicationItem,
  CommunicationList,
  KpiCard,
  BadgeContainer,
  PriorityBadge,
  ActionButtonsContainer
} from "./styles";

const mockContasBase = [
  {
    descricao: "Venda Produto X",
    valor: 2500,
    vencimento: "2025-04-15",
    status: "pendente",
    tipo_recebimento: "cliente",
    cliente: "Empresa ABC",
    forma_recebimento: "Boleto",
    categoria: "Vendas",
    numero_documento: "NF123",
    centro_custo: "Comercial",
    observacoes: "Cliente prioritário.",
    prioridade: "alta"
  },
  {
    descricao: "Prestação de Serviço",
    valor: 1200,
    vencimento: "2025-04-12",
    status: "recebido",
    tipo_recebimento: "cliente",
    cliente: "João Silva",
    forma_recebimento: "Pix",
    categoria: "Serviços",
    numero_documento: "NF456",
    centro_custo: "Operacional",
    observacoes: "",
    data_recebimento: "2025-04-10",
    prioridade: "média"
  },
  {
    descricao: "Mensalidade Assinatura",
    valor: 890,
    vencimento: "2025-04-05",
    status: "pendente",
    tipo_recebimento: "assinatura",
    cliente: "Maria Oliveira",
    forma_recebimento: "Cartão de Crédito",
    categoria: "Assinaturas",
    numero_documento: "REC789",
    centro_custo: "Recorrentes",
    observacoes: "Assinatura mensal",
    prioridade: "baixa"
  },
  {
    descricao: "Royalties Licenciamento",
    valor: 350,
    vencimento: "2025-03-28",
    status: "atrasado",
    tipo_recebimento: "parceiro",
    cliente: "Editora XYZ",
    forma_recebimento: "Transferência",
    categoria: "Licenciamento",
    numero_documento: "ROY999",
    centro_custo: "Propriedade Intelectual",
    observacoes: "Contrato anual",
    prioridade: "média"
  },
  {
    descricao: "Reembolso Despesas",
    valor: 480,
    vencimento: "2025-04-20",
    status: "pendente",
    tipo_recebimento: "reembolso",
    cliente: "Parceiro Comercial",
    forma_recebimento: "Transferência",
    categoria: "Reembolsos",
    numero_documento: "REEMB1234",
    centro_custo: "Administrativo",
    observacoes: "",
    prioridade: "baixa"
  },
  {
    descricao: "Consultoria Financeira",
    valor: 3200,
    vencimento: "2025-04-18",
    status: "pendente",
    tipo_recebimento: "cliente",
    cliente: "Construtora Horizonte",
    forma_recebimento: "Boleto",
    categoria: "Consultoria",
    numero_documento: "NF5678",
    centro_custo: "Projetos",
    observacoes: "Segunda parcela do projeto",
    prioridade: "alta"
  }
];

// Cores para gráficos
const COLORS = {
  pendente: "#f59e0b",
  recebido: "#10b981",
  atrasado: "#ef4444",
  vendas: "#8b5cf6",
  servicos: "#3b82f6",
  assinaturas: "#ec4899",
  licenciamento: "#6366f1",
  reembolsos: "#14b8a6",
  consultoria: "#f97316",
  alta: "#ef4444",
  média: "#f59e0b",
  baixa: "#10b981"
};

function getInicioMes() {
  const data = new Date();
  return `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}-01`;
}

function getFimMes() {
  const data = new Date();
  return new Date(data.getFullYear(), data.getMonth() + 1, 0).toISOString().split('T')[0];
}

export default function ContasReceber() {
  const [contas, setContas] = useState([]);
  const [filtroStatus, setFiltroStatus] = useState("todos");
  const [filtroPeriodo, setFiltroPeriodo] = useState({ de: getInicioMes(), ate: getFimMes() });
  const [filtroCliente, setFiltroCliente] = useState("");
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const [filtroPrioridade, setFiltroPrioridade] = useState("todas");
  const [resumoStatus, setResumoStatus] = useState({});
  const [resumoCategoria, setResumoCategoria] = useState([]);
  const [resumoFormaRecebimento, setResumoFormaRecebimento] = useState([]);
  const [resumoCentroCusto, setResumoCentroCusto] = useState([]);
  const [fluxoMensal, setFluxoMensal] = useState([]);
  const [mediaDiasAtraso, setMediaDiasAtraso] = useState(0);
  const [previsaoRecebimentos, setPrevisaoRecebimentos] = useState([]);
  const [recomendacoes, setRecomendacoes] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalRecebimento, setModalRecebimento] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({});
  const [confirmarExclusao, setConfirmarExclusao] = useState(null);
  const [marcandoComoRecebido, setMarcandoComoRecebido] = useState(null);
  const [exibirDetalhes, setExibirDetalhes] = useState(false);
  const [pesquisa, setPesquisa] = useState("");
  const [visualizacao, setVisualizacao] = useState("tabela");
  const [clientes, setClientes] = useState([]);
  const [contaSelecionada, setContaSelecionada] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [formasRecebimento, setFormasRecebimento] = useState([]);
  const [centrosCusto, setCentrosCusto] = useState([]);
  const [mostrarFiltrosAvancados, setMostrarFiltrosAvancados] = useState(false);
  const [tabAtiva, setTabAtiva] = useState("detalhes");
  const [comunicacoes, setComunicacoes] = useState([]);
  const [novaComunicacao, setNovaComunicacao] = useState("");
  const [novaTag, setNovaTag] = useState("");
  const [anexos, setAnexos] = useState([]);
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);

  const filtrarContas = () => {
    let resultado = [...mockContasBase];

    if (filtroStatus !== "todos") {
      resultado = resultado.filter(c => c.status === filtroStatus);
    }

    if (filtroPeriodo.de) {
      resultado = resultado.filter(c => new Date(c.vencimento) >= new Date(filtroPeriodo.de));
    }

    if (filtroPeriodo.ate) {
      resultado = resultado.filter(c => new Date(c.vencimento) <= new Date(filtroPeriodo.ate));
    }

    if (filtroCliente) {
      resultado = resultado.filter(c => c.cliente.toLowerCase().includes(filtroCliente.toLowerCase()));
    }

    if (filtroCategoria) {
      resultado = resultado.filter(c => c.categoria === filtroCategoria);
    }

    if (filtroPrioridade !== "todas") {
      resultado = resultado.filter(c => c.prioridade === filtroPrioridade);
    }

    if (pesquisa) {
      const termoLower = pesquisa.toLowerCase();
      resultado = resultado.filter(c =>
        c.descricao.toLowerCase().includes(termoLower) ||
        c.cliente.toLowerCase().includes(termoLower) ||
        c.categoria.toLowerCase().includes(termoLower) ||
        c.numero_documento.toLowerCase().includes(termoLower)
      );
    }

    setContas(resultado);
    atualizarDashboard(resultado);
    setRecomendacoes(gerarRecomendacoes(resultado));
  };

  const atualizarDashboard = (lista) => {
    // Resumo por status
    const resumo = {
      pendente: lista.filter(c => c.status === "pendente").reduce((acc, c) => acc + c.valor, 0),
      recebido: lista.filter(c => c.status === "recebido").reduce((acc, c) => acc + c.valor, 0),
      atrasado: lista.filter(c => c.status === "atrasado").reduce((acc, c) => acc + c.valor, 0)
    };
    setResumoStatus(resumo);

    // Dados para gráfico de pizza - por categoria
    const categorias = {};
    lista.forEach(c => {
      if (!categorias[c.categoria]) categorias[c.categoria] = 0;
      categorias[c.categoria] += c.valor;
    });
    const resumoCat = Object.keys(categorias).map(cat => ({
      name: cat,
      value: categorias[cat]
    }));
    setResumoCategoria(resumoCat);

    // Dados para gráfico de barras - formas de recebimento
    const formas = {};
    lista.forEach(c => {
      if (!formas[c.forma_recebimento]) formas[c.forma_recebimento] = 0;
      formas[c.forma_recebimento] += c.valor;
    });
    const resumoFormas = Object.keys(formas).map(forma => ({
      name: forma,
      value: formas[forma]
    }));
    setResumoFormaRecebimento(resumoFormas);

    // Dados para gráfico de barras - centro de custo
    const centros = {};
    lista.forEach(c => {
      if (!centros[c.centro_custo]) centros[c.centro_custo] = 0;
      centros[c.centro_custo] += c.valor;
    });
    const resumoCentros = Object.keys(centros).map(centro => ({
      name: centro,
      value: centros[centro]
    }));
    setResumoCentroCusto(resumoCentros);

    // Dados para fluxo mensal
    const meses = {};
    lista.forEach(c => {
      const mesAno = c.vencimento.substring(0, 7);
      if (!meses[mesAno]) meses[mesAno] = { pendente: 0, recebido: 0, atrasado: 0 };
      meses[mesAno][c.status] += c.valor;
    });
    const fluxo = Object.keys(meses).sort().map(mesAno => ({
      name: formatarMesAno(mesAno),
      pendente: meses[mesAno].pendente,
      recebido: meses[mesAno].recebido,
      atrasado: meses[mesAno].atrasado
    }));
    setFluxoMensal(fluxo);

    // Calcular média de dias em atraso
    const hoje = new Date();
    const contasAtrasadas = lista.filter(c => c.status === "atrasado");
    if (contasAtrasadas.length > 0) {
      const diasAtraso = contasAtrasadas.reduce((acc, c) => {
        const dataVencimento = new Date(c.vencimento);
        const diff = Math.floor((hoje - dataVencimento) / (1000 * 60 * 60 * 24));
        return acc + diff;
      }, 0);
      setMediaDiasAtraso(Math.round(diasAtraso / contasAtrasadas.length));
    } else {
      setMediaDiasAtraso(0);
    }

    // Projeção para os próximos 3 meses
    const projecaoMeses = [];
    const dataBase = new Date();
    for (let i = 0; i < 4; i++) {
      const dataProj = new Date(dataBase);
      dataProj.setMonth(dataBase.getMonth() + i);
      const mesAno = `${dataProj.getFullYear()}-${String(dataProj.getMonth() + 1).padStart(2, '0')}`;

      // Somar valores de contas pendentes para este mês
      const valorMes = lista
        .filter(c => c.status === "pendente" && c.vencimento.startsWith(mesAno))
        .reduce((acc, c) => acc + c.valor, 0);

      projecaoMeses.push({
        name: formatarMesAno(mesAno),
        valor: valorMes
      });
    }
    setPrevisaoRecebimentos(projecaoMeses);

    // Extrair listas de clientes, categorias, etc.
    const clientesUnicos = [...new Set(lista.filter(c => c.cliente).map(c => c.cliente))];
    const categoriasUnicas = [...new Set(lista.map(c => c.categoria))];
    const formasRecebimentoUnicas = [...new Set(lista.map(c => c.forma_recebimento))];
    const centrosCustoUnicos = [...new Set(lista.map(c => c.centro_custo))];

    setClientes(clientesUnicos);
    setCategorias(categoriasUnicas);
    setFormasRecebimento(formasRecebimentoUnicas);
    setCentrosCusto(centrosCustoUnicos);
  };

  const formatarMesAno = (mesAno) => {
    const [ano, mes] = mesAno.split('-');
    const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    return `${meses[parseInt(mes) - 1]}/${ano}`;
  };

  const gerarRecomendacoes = (lista) => {
    const hoje = new Date();
    const proximas = lista.filter(c => c.status === 'pendente' && new Date(c.vencimento) <= new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + 2));
    const recorrentes = lista.filter(c => c.observacoes.toLowerCase().includes('mensal'));
    const dicas = [];

    if (lista.some(c => c.status === 'atrasado')) {
      dicas.push("🔴 Você tem contas atrasadas. Entre em contato com o cliente para verificar o status.");
    }

    if (proximas.length > 0) {
      dicas.push(`🟡 Você tem ${proximas.length} contas a receber nos próximos 2 dias.`);
    }

    if (recorrentes.length > 0) {
      dicas.push(`🔁 Lembre-se de registrar a próxima cobrança mensal para '${recorrentes[0].cliente}'`);
    }

    // Novas recomendações baseadas em análise
    const totalPendente = lista.filter(c => c.status === 'pendente').reduce((acc, c) => acc + c.valor, 0);
    const categoriaMaisExpressiva = [...resumoCategoria].sort((a, b) => b.value - a.value)[0];

    if (categoriaMaisExpressiva && categoriaMaisExpressiva.value > totalPendente * 0.4) {
      dicas.push(`📊 A categoria '${categoriaMaisExpressiva.name}' representa mais de 40% dos seus recebimentos. Considere diversificar suas fontes de receita.`);
    }

    // Análise de fluxo de caixa
    const totalPendenteProximos30Dias = lista.filter(c =>
      c.status === 'pendente' &&
      (new Date(c.vencimento) <= new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + 30))
    ).reduce((acc, c) => acc + c.valor, 0);

    if (totalPendenteProximos30Dias < totalPendente * 0.3) {
      dicas.push(`💰 Atenção ao fluxo de caixa! Menos de 30% dos seus recebimentos estão previstos para os próximos 30 dias.`);
    }

    // Recomendação para clientes de alta prioridade
    const clientesAlta = lista.filter(c => c.prioridade === 'alta' && c.status === 'pendente');
    if (clientesAlta.length > 0) {
      dicas.push(`⭐ Você tem ${clientesAlta.length} recebimentos pendentes de clientes de alta prioridade.`);
    }

    return dicas;
  };

  useEffect(() => {
    filtrarContas();

    // Criar dados de comunicação mock
    const comunicacoesMock = [
      { data: "2025-04-10", mensagem: "Cliente informou que pagará na data de vencimento", autor: "Maria Silva" },
      { data: "2025-04-08", mensagem: "E-mail enviado com boleto atualizado", autor: "João Santos" },
      { data: "2025-04-05", mensagem: "Cliente solicitou mais detalhes sobre o serviço", autor: "Maria Silva" }
    ];
    setComunicacoes(comunicacoesMock);

    // Criar dados de anexos mock
    const anexosMock = [
      { nome: "Nota_Fiscal_123.pdf", tipo: "pdf", tamanho: "245KB", data: "2025-04-01" },
      { nome: "Contrato_Assinado.pdf", tipo: "pdf", tamanho: "1.2MB", data: "2025-03-28" }
    ];
    setAnexos(anexosMock);

  }, []);

  const toggleFiltrosAvancados = () => {
    setMostrarFiltrosAvancados(!mostrarFiltrosAvancados);
  };

  const abrirModal = (conta = null) => {
    setEditando(conta);
    setForm(conta || {
      descricao: "",
      valor: 0,
      vencimento: "",
      status: "pendente",
      tipo_recebimento: "cliente",
      cliente: "",
      forma_recebimento: "",
      categoria: "",
      numero_documento: Date.now().toString(),
      centro_custo: "",
      observacoes: "",
      data_recebimento: "",
      anexos: [],
      competencia: "",
      conciliado: "Não conciliado",
      tags: [],
      repetir_mensalmente: false,
      prioridade: "média"
    });
    setModalOpen(true);
  };

  const fecharModal = () => {
    setModalOpen(false);
    setModalRecebimento(false);
    setContaSelecionada(null);
    setConfirmarExclusao(null);
  };
  
  const salvarConta = () => {
    if (editando) {
      const atualizadas = contas.map(c => c.numero_documento === editando.numero_documento ? form : c);
      setContas(atualizadas);
      atualizarDashboard(atualizadas);
    } else {
      const novasContas = [...contas, form];
      setContas(novasContas);
      atualizarDashboard(novasContas);
    }
    setModalOpen(false);
  };

  const abrirModalRecebimento = (conta) => {
    setMarcandoComoRecebido(conta);
    setForm({ ...conta, data_recebimento: new Date().toISOString().split("T")[0] });
    setModalRecebimento(true);
  };

  const salvarRecebimento = () => {
    const atualizadas = contas.map(c =>
      c.numero_documento === marcandoComoRecebido.numero_documento
        ? { ...c, status: "recebido", data_recebimento: form.data_recebimento }
        : c
    );
    setContas(atualizadas);
    atualizarDashboard(atualizadas);
    setMarcandoComoRecebido(null);
    setModalRecebimento(false);
  };

  const excluirConta = () => {
    const atualizadas = contas.filter(c => c.numero_documento !== confirmarExclusao.numero_documento);
    setContas(atualizadas);
    atualizarDashboard(atualizadas);
    setConfirmarExclusao(null);
  };

  const adicionarComunicacao = () => {
    if (!novaComunicacao.trim()) return;

    const novaComunicacaoObj = {
      data: new Date().toISOString().split("T")[0],
      mensagem: novaComunicacao,
      autor: "Você"
    };

    setComunicacoes([novaComunicacaoObj, ...comunicacoes]);
    setNovaComunicacao("");
  };

  const adicionarTag = () => {
    if (!novaTag.trim() || !form.tags) return;
    if (form.tags.includes(novaTag)) return;

    setForm({
      ...form,
      tags: [...form.tags, novaTag]
    });
    setNovaTag("");
  };

  const removerTag = (tagParaRemover) => {
    setForm({
      ...form,
      tags: form.tags.filter(tag => tag !== tagParaRemover)
    });
  };

  const adicionarAnexo = () => {
    if (!arquivoSelecionado) return;

    const novoAnexo = {
      nome: arquivoSelecionado.name,
      tipo: arquivoSelecionado.name.split('.').pop(),
      tamanho: `${Math.round(arquivoSelecionado.size / 1024)}KB`,
      data: new Date().toISOString().split("T")[0]
    };

    setAnexos([...anexos, novoAnexo]);
    setArquivoSelecionado(null);
  };

  const formatarData = (data) => {
    if (!data) return "-";
    const partes = data.split("T")[0].split("-");
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  };

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  const calcularProximosVencimentos = () => {
    const hoje = new Date();
    return contas
      .filter(c => c.status === 'pendente')
      .sort((a, b) => new Date(a.vencimento) - new Date(b.vencimento))
      .slice(0, 5);
  };

  const abrirDetalhesConta = (conta) => {
    setContaSelecionada(conta);
  };

  const marcarTodasAtrasadasComoRecebidas = () => {
    const contasAtrasadas = contas.filter(c => c.status === 'atrasado');
    if (contasAtrasadas.length === 0) return;

    const hoje = new Date().toISOString().split('T')[0];
    const atualizadas = contas.map(c =>
      c.status === 'atrasado' ? { ...c, status: 'recebido', data_recebimento: hoje } : c
    );

    setContas(atualizadas);
    atualizarDashboard(atualizadas);
    setRecomendacoes(gerarRecomendacoes(atualizadas));
  };

  const exportarDados = () => {
    // Formatar dados para exportação
    const dadosParaExportar = contas.map(c => ({
      Descrição: c.descricao,
      Valor: formatarMoeda(c.valor),
      Vencimento: formatarData(c.vencimento),
      Status: c.status,
      Cliente: c.cliente,
      "Forma de Recebimento": c.forma_recebimento,
      Categoria: c.categoria,
      "Número do Documento": c.numero_documento,
      "Centro de Custo": c.centro_custo,
      "Data de Recebimento": formatarData(c.data_recebimento),
      Observações: c.observacoes,
      Prioridade: c.prioridade
    }));

    // Criar CSV
    const headers = Object.keys(dadosParaExportar[0]).join(',');
    const rows = dadosParaExportar.map(obj => Object.values(obj).map(v => `"${v}"`).join(',')).join('\n');
    const csv = `${headers}\n${rows}`;

    // Download do arquivo
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', 'contas_a_receber.csv');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <>
      <Header />
      <Container>
        <PageHeader>Contas a Receber</PageHeader>

        <SummaryCardsContainer>
          <AnimatedCard>
            <SummaryCard status="pendente">
              <SummaryLabel>A Receber</SummaryLabel>
              <SummaryValue>{formatarMoeda(resumoStatus.pendente || 0)}</SummaryValue>
            </SummaryCard>
          </AnimatedCard>
          <AnimatedCard delay="0.1s">
            <SummaryCard status="recebido">
              <SummaryLabel>Recebido</SummaryLabel>
              <SummaryValue>{formatarMoeda(resumoStatus.recebido || 0)}</SummaryValue>
            </SummaryCard>
          </AnimatedCard>
          <AnimatedCard delay="0.2s">
            <SummaryCard status="atrasado">
              <SummaryLabel>Atrasado</SummaryLabel>
              <SummaryValue>{formatarMoeda(resumoStatus.atrasado || 0)}</SummaryValue>
            </SummaryCard>
          </AnimatedCard>
          <AnimatedCard delay="0.3s">
            <SummaryCard>
              <SummaryLabel>Total</SummaryLabel>
              <SummaryValue>
                {formatarMoeda((resumoStatus.pendente || 0) + (resumoStatus.recebido || 0) + (resumoStatus.atrasado || 0))}
              </SummaryValue>
            </SummaryCard>
          </AnimatedCard>
        </SummaryCardsContainer>

        <FilterRow>
          <div>
            <FilterLabel>Status:</FilterLabel>
            <Select
              value={filtroStatus}
              onChange={(e) => {
                setFiltroStatus(e.target.value);
                filtrarContas();
              }}
            >
              <option value="todos">Todos</option>
              <option value="pendente">Pendente</option>
              <option value="recebido">Recebido</option>
              <option value="atrasado">Atrasado</option>
            </Select>
          </div>

          <div>
            <FilterLabel>De:</FilterLabel>
            <Input
              type="date"
              value={filtroPeriodo.de}
              onChange={(e) => {
                setFiltroPeriodo({ ...filtroPeriodo, de: e.target.value });
                filtrarContas();
              }}
            />
          </div>

          <div>
            <FilterLabel>Até:</FilterLabel>
            <Input
              type="date"
              value={filtroPeriodo.ate}
              onChange={(e) => {
                setFiltroPeriodo({ ...filtroPeriodo, ate: e.target.value });
                filtrarContas();
              }}
            />
          </div>

          <div>
            <FilterLabel>Prioridade:</FilterLabel>
            <Select
              value={filtroPrioridade}
              onChange={(e) => {
                setFiltroPrioridade(e.target.value);
                filtrarContas();
              }}
            >
              <option value="todas">Todas</option>
              <option value="alta">Alta</option>
              <option value="média">Média</option>
              <option value="baixa">Baixa</option>
            </Select>
          </div>

          <Input
            type="text"
            placeholder="Pesquisar..."
            value={pesquisa}
            onChange={(e) => {
              setPesquisa(e.target.value);
              filtrarContas();
            }}
          />

          <FilterToggle onClick={toggleFiltrosAvancados}>
            {mostrarFiltrosAvancados ? "- Filtros" : "+ Filtros Avançados"}
          </FilterToggle>

          <ViewToggleButton
            active={visualizacao === "tabela"}
            onClick={() => setVisualizacao("tabela")}
          >
            Tabela
          </ViewToggleButton>
          <ViewToggleButton
            active={visualizacao === "dashboard"}
            onClick={() => setVisualizacao("dashboard")}
          >
            Dashboard
          </ViewToggleButton>
        </FilterRow>

        {mostrarFiltrosAvancados && (
          <AdvancedFiltersContainer>
            <FilterGroup>
              <FilterLabel>Cliente:</FilterLabel>
              <Select
                value={filtroCliente}
                onChange={(e) => {
                  setFiltroCliente(e.target.value);
                  filtrarContas();
                }}
              >
                <option value="">Todos</option>
                {clientes.map((cliente, idx) => (
                  <option key={idx} value={cliente}>{cliente}</option>
                ))}
              </Select>
            </FilterGroup>
            <FilterGroup>
              <FilterLabel>Categoria:</FilterLabel>
              <Select
                value={filtroCategoria}
                onChange={(e) => {
                  setFiltroCategoria(e.target.value);
                  filtrarContas();
                }}
              >
                <option value="">Todas</option>
                {categorias.map((categoria, idx) => (
                  <option key={idx} value={categoria}>{categoria}</option>
                ))}
              </Select>
            </FilterGroup>
          </AdvancedFiltersContainer>
        )}

        <ActionPanel>
          <AddButton onClick={() => abrirModal()}>+ Novo Recebimento</AddButton>
          <ExportButton onClick={exportarDados}>Exportar CSV</ExportButton>
          {contas.some(c => c.status === "atrasado") && (
            <BatchActionButton onClick={() => marcarTodasAtrasadasComoRecebidas()}>
              Marcar Todos Atrasados Como Recebidos
            </BatchActionButton>
          )}
        </ActionPanel>

        {visualizacao === "tabela" ? (
          <>
            <TableWrapper>
              <Table>
                <thead>
                  <tr>
                    <TableHeader>Descrição</TableHeader>
                    <TableHeader>Valor</TableHeader>
                    <TableHeader>Cliente</TableHeader>
                    <TableHeader>Vencimento</TableHeader>
                    <TableHeader>Status</TableHeader>
                    <TableHeader>Categoria</TableHeader>
                    <TableHeader>Prioridade</TableHeader>
                    <TableHeader>Ações</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {contas.length > 0 ? (
                    contas.map((conta) => (
                      <TableRow key={conta.numero_documento} status={conta.status}>
                        <TableCell onClick={() => abrirDetalhesConta(conta)} style={{ cursor: 'pointer' }}>
                          {conta.descricao}
                        </TableCell>
                        <TableCell>{formatarMoeda(conta.valor)}</TableCell>
                        <TableCell>{conta.cliente}</TableCell>
                        <TableCell>{formatarData(conta.vencimento)}</TableCell>
                        <TableCell>
                          <StatusBadge status={conta.status}>
                            {conta.status === "pendente" && "Pendente"}
                            {conta.status === "recebido" && "Recebido"}
                            {conta.status === "atrasado" && "Atrasado"}
                          </StatusBadge>
                        </TableCell>
                        <TableCell>{conta.categoria}</TableCell>
                        <TableCell>
                          <PriorityBadge prioridade={conta.prioridade}>
                            {conta.prioridade}
                          </PriorityBadge>
                        </TableCell>
                        <TableCell>
                          <ActionButtonsContainer>
                            {conta.status !== "recebido" && (
                              <ActionButton
                                color="green"
                                onClick={() => abrirModalRecebimento(conta)}
                              >
                                Recebido
                              </ActionButton>
                            )}
                            <ActionButton
                              color="blue"
                              onClick={() => abrirModal(conta)}
                            >
                              Editar
                            </ActionButton>
                            <ActionButton
                              color="red"
                              onClick={() => setConfirmarExclusao(conta)}
                            >
                              Excluir
                            </ActionButton>
                          </ActionButtonsContainer>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan="8">
                        <EmptyState>
                          Nenhuma conta encontrada com os filtros atuais.
                        </EmptyState>
                      </TableCell>
                    </TableRow>
                  )}
                </tbody>
              </Table>
            </TableWrapper>

            {/* Seção de Recomendações */}
            <RecomendationsContainer>
              <RecomendationsTitle>Recomendações e Lembretes</RecomendationsTitle>
              <RecomendationsList>
                {recomendacoes.map((rec, idx) => (
                  <li key={idx}>{rec}</li>
                ))}
              </RecomendationsList>
            </RecomendationsContainer>
          </>
        ) : (
          // Dashboard View
          <>
            <DashboardGrid>
              <DashboardCard>
                <DashboardCardTitle>Distribuição por Status</DashboardCardTitle>
                <ResponsiveContainer width="100%" height={250}>
                  <PieChart>
                    <Pie
                      data={[
                        { name: "Pendente", value: resumoStatus.pendente || 0 },
                        { name: "Recebido", value: resumoStatus.recebido || 0 },
                        { name: "Atrasado", value: resumoStatus.atrasado || 0 }
                      ]}
                      cx="50%"
                      cy="50%"
                      outerRadius={80}
                      dataKey="value"
                      labelLine={false}
                      label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                    >
                      <Cell fill={COLORS.pendente} />
                      <Cell fill={COLORS.recebido} />
                      <Cell fill={COLORS.atrasado} />
                    </Pie>
                    <Tooltip formatter={(value) => formatarMoeda(value)} />
                  </PieChart>
                </ResponsiveContainer>
              </DashboardCard>

              <DashboardCard>
                <DashboardCardTitle>Distribuição por Categoria</DashboardCardTitle>
                <ResponsiveContainer width="100%" height={250}>
                  <PieChart>
                    <Pie
                      data={resumoCategoria}
                      cx="50%"
                      cy="50%"
                      outerRadius={80}
                      dataKey="value"
                      labelLine={false}
                      label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                    >
                      {resumoCategoria.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[entry.name.toLowerCase()] || `hsl(${index * 45}, 70%, 50%)`}
                        />
                      ))}
                    </Pie>
                    <Tooltip formatter={(value) => formatarMoeda(value)} />
                  </PieChart>
                </ResponsiveContainer>
              </DashboardCard>

              <DashboardCard>
                <DashboardCardTitle>Fluxo Mensal</DashboardCardTitle>
                <ResponsiveContainer width="100%" height={250}>
                  <BarChart
                    data={fluxoMensal}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip formatter={(value) => formatarMoeda(value)} />
                    <Legend />
                    <Bar dataKey="pendente" name="Pendente" fill={COLORS.pendente} />
                    <Bar dataKey="recebido" name="Recebido" fill={COLORS.recebido} />
                    <Bar dataKey="atrasado" name="Atrasado" fill={COLORS.atrasado} />
                  </BarChart>
                </ResponsiveContainer>
              </DashboardCard>

              <DashboardCard>
                <DashboardCardTitle>Formas de Recebimento</DashboardCardTitle>
                <ResponsiveContainer width="100%" height={250}>
                  <BarChart
                    data={resumoFormaRecebimento}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    layout="vertical"
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis type="number" />
                    <YAxis dataKey="name" type="category" width={100} />
                    <Tooltip formatter={(value) => formatarMoeda(value)} />
                    <Legend />
                    <Bar dataKey="value" name="Valor" fill="#8884d8" />
                  </BarChart>
                </ResponsiveContainer>
              </DashboardCard>

              <DashboardCard>
                <DashboardCardTitle>Previsão de Recebimentos</DashboardCardTitle>
                <ResponsiveContainer width="100%" height={250}>
                  <LineChart
                    data={previsaoRecebimentos}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip formatter={(value) => formatarMoeda(value)} />
                    <Legend />
                    <Line type="monotone" dataKey="valor" name="Valor Previsto" stroke="#8884d8" activeDot={{ r: 8 }} />
                  </LineChart>
                </ResponsiveContainer>
              </DashboardCard>

              <DashboardCard>
                <DashboardCardTitle>Centro de Custo</DashboardCardTitle>
                <ResponsiveContainer width="100%" height={250}>
                  <BarChart
                    data={resumoCentroCusto}
                    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    layout="vertical"
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis type="number" />
                    <YAxis dataKey="name" type="category" width={100} />
                    <Tooltip formatter={(value) => formatarMoeda(value)} />
                    <Legend />
                    <Bar dataKey="value" name="Valor" fill="#82ca9d" />
                  </BarChart>
                </ResponsiveContainer>
              </DashboardCard>

              <KpiCard>
                <SummaryLabel>Média de Dias em Atraso</SummaryLabel>
                <SummaryValue>{mediaDiasAtraso} dias</SummaryValue>
              </KpiCard>

              <KpiCard>
                <SummaryLabel>Clientes com Pagamentos Pendentes</SummaryLabel>
                <SummaryValue>
                  {new Set(contas.filter(c => c.status === "pendente").map(c => c.cliente)).size}
                </SummaryValue>
              </KpiCard>

              <KpiCard>
                <SummaryLabel>Taxa de Recebimento</SummaryLabel>
                <SummaryValue>
                  {contas.length > 0
                    ? `${Math.round((contas.filter(c => c.status === "recebido").length / contas.length) * 100)}%`
                    : "0%"}
                </SummaryValue>
              </KpiCard>

              <NextPaymentsContainer>
                <SectionTitle>Próximos Vencimentos</SectionTitle>
                <NextPaymentsList>
                  {calcularProximosVencimentos().map((conta) => (
                    <NextPaymentCard key={conta.numero_documento} status={conta.status}>
                      <div>
                        <strong>{conta.descricao}</strong>
                        <div>{formatarMoeda(conta.valor)}</div>
                        <div>{conta.cliente}</div>
                        <PriorityBadge prioridade={conta.prioridade}>
                          {conta.prioridade}
                        </PriorityBadge>
                      </div>
                      <div>
                        <div>Vence em: {formatarData(conta.vencimento)}</div>
                        <StatusBadge status={conta.status}>
                          {conta.status === "pendente" && "Pendente"}
                          {conta.status === "recebido" && "Recebido"}
                          {conta.status === "atrasado" && "Atrasado"}
                        </StatusBadge>
                      </div>
                    </NextPaymentCard>
                  ))}
                </NextPaymentsList>
              </NextPaymentsContainer>
            </DashboardGrid>
          </>
        )}

        {/* Modal de Nova/Editar Conta */}
        {modalOpen && (
          
<ModalOverlay>
  <ModalContent>
    <ModalTitle>{editando ? "Editar Recebimento" : "Novo Recebimento"}</ModalTitle>

    <TabsContainer>
      <Tab active={tabAtiva === "detalhes"} onClick={() => setTabAtiva("detalhes")}>Detalhes</Tab>
      <Tab active={tabAtiva === "anexos"} onClick={() => setTabAtiva("anexos")}>Anexos</Tab>
      <Tab active={tabAtiva === "comunicacoes"} onClick={() => setTabAtiva("comunicacoes")}>Comunicações</Tab>
    </TabsContainer>
<Tab active={tabAtiva === "cliente"} onClick={() => setTabAtiva("cliente")}>Cliente</Tab>

    <TabContent visible={tabAtiva === "detalhes"}>
      <FilterGroup>
        <FilterLabel>Descrição:</FilterLabel>
        <Input value={form.descricao || ""} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Valor:</FilterLabel>
        <Input type="number" value={form.valor || ""} onChange={(e) => setForm({ ...form, valor: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Vencimento:</FilterLabel>
        <Input type="date" value={form.vencimento || ""} onChange={(e) => setForm({ ...form, vencimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Recebimento:</FilterLabel>
        <Input type="date" value={form.data_recebimento || ""} onChange={(e) => setForm({ ...form, data_recebimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Status:</FilterLabel>
        <Select value={form.status || "pendente"} onChange={(e) => setForm({ ...form, status: e.target.value })}>
          <option value="pendente">Pendente</option>
          <option value="recebido">Recebido</option>
          <option value="atrasado">Atrasado</option>
          <option value="parcial">Parcial</option>
        </Select>
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Forma de Recebimento:</FilterLabel>
        <Input value={form.forma_recebimento || ""} onChange={(e) => setForm({ ...form, forma_recebimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Categoria:</FilterLabel>
        <Input value={form.categoria || ""} onChange={(e) => setForm({ ...form, categoria: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Centro de Custo:</FilterLabel>
        <Input value={form.centro_custo || ""} onChange={(e) => setForm({ ...form, centro_custo: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Desconto Concedido:</FilterLabel>
        <Input type="number" value={form.desconto || ""} onChange={(e) => setForm({ ...form, desconto: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Juros Aplicado:</FilterLabel>
        <Input type="number" value={form.juros || ""} onChange={(e) => setForm({ ...form, juros: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Observações:</FilterLabel>
        <TextArea value={form.observacoes || ""} onChange={(e) => setForm({ ...form, observacoes: e.target.value })} />
      </FilterGroup>
    </TabContent>

    <TabContent visible={tabAtiva === "anexos"}>
      {/* Área para upload de anexos */}
    </TabContent>

    <TabContent visible={tabAtiva === "comunicacoes"}>
      {/* Área para mensagens, históricos ou logs */}
    </TabContent>

    
<TabContent visible={tabAtiva === "cliente"}>
  <FilterGroup>
    <FilterLabel>Nome/Razão Social:</FilterLabel>
    <Input value={form.cliente_nome || ""} onChange={(e) => setForm({ ...form, cliente_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF/CNPJ:</FilterLabel>
    <Input value={form.cliente_cnpj || ""} onChange={(e) => setForm({ ...form, cliente_cnpj: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Telefone:</FilterLabel>
    <Input value={form.cliente_telefone || ""} onChange={(e) => setForm({ ...form, cliente_telefone: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Email:</FilterLabel>
    <Input value={form.cliente_email || ""} onChange={(e) => setForm({ ...form, cliente_email: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo:</FilterLabel>
    <Select value={form.cliente_tipo || "pj"} onChange={(e) => setForm({ ...form, cliente_tipo: e.target.value })}>
      <option value="pj">Pessoa Jurídica</option>
      <option value="pf">Pessoa Física</option>
    </Select>
  </FilterGroup>
</TabContent>



<TabContent visible={tabAtiva === "cliente"}>
  <FilterGroup>
    
<FilterGroup>
  <FilterLabel>Tipo de Cliente:</FilterLabel>
  <Select value={form.cliente_tipo || "pj"} onChange={(e) => setForm({ ...form, cliente_tipo: e.target.value })}>
    <option value="pj">Pessoa Jurídica</option>
    <option value="pf">Pessoa Física</option>
  </Select>
</FilterGroup>


  <FilterLabel>Nome/Razão Social:</FilterLabel>
    <Input value={form.cliente_nome || ""} onChange={(e) => setForm({ ...form, cliente_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF/CNPJ:</FilterLabel>
    <Input value={form.cliente_cnpj || ""} onChange={(e) => setForm({ ...form, cliente_cnpj: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Telefone:</FilterLabel>
    <Input value={form.cliente_telefone || ""} onChange={(e) => setForm({ ...form, cliente_telefone: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Email:</FilterLabel>
    <Input value={form.cliente_email || ""} onChange={(e) => setForm({ ...form, cliente_email: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo:</FilterLabel>
    <Select value={form.cliente_tipo || "pj"} onChange={(e) => setForm({ ...form, cliente_tipo: e.target.value })}>
      <option value="pj">Pessoa Jurídica</option>
      <option value="pf">Pessoa Física</option>
    </Select>
  </FilterGroup>
</TabContent>


<ModalActions>
      <ButtonCancelar onClick={fecharModal}>Cancelar</ButtonCancelar>
      <ButtonSalvar onClick={salvarRecebimento}>Salvar</ButtonSalvar>
    </ModalActions>
  </ModalContent>
</ModalOverlay>

        )}

        {/* Modal de Marcar como Recebido */}
        {modalRecebimento && (
          
<ModalOverlay>
  <ModalContent>
    <ModalTitle>{editando ? "Editar Recebimento" : "Novo Recebimento"}</ModalTitle>

    <TabsContainer>
      <Tab active={tabAtiva === "detalhes"} onClick={() => setTabAtiva("detalhes")}>Detalhes</Tab>
      <Tab active={tabAtiva === "anexos"} onClick={() => setTabAtiva("anexos")}>Anexos</Tab>
      <Tab active={tabAtiva === "comunicacoes"} onClick={() => setTabAtiva("comunicacoes")}>Comunicações</Tab>
    </TabsContainer>
<Tab active={tabAtiva === "cliente"} onClick={() => setTabAtiva("cliente")}>Cliente</Tab>

    <TabContent visible={tabAtiva === "detalhes"}>
      <FilterGroup>
        <FilterLabel>Descrição:</FilterLabel>
        <Input value={form.descricao || ""} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Valor:</FilterLabel>
        <Input type="number" value={form.valor || ""} onChange={(e) => setForm({ ...form, valor: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Vencimento:</FilterLabel>
        <Input type="date" value={form.vencimento || ""} onChange={(e) => setForm({ ...form, vencimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Recebimento:</FilterLabel>
        <Input type="date" value={form.data_recebimento || ""} onChange={(e) => setForm({ ...form, data_recebimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Status:</FilterLabel>
        <Select value={form.status || "pendente"} onChange={(e) => setForm({ ...form, status: e.target.value })}>
          <option value="pendente">Pendente</option>
          <option value="recebido">Recebido</option>
          <option value="atrasado">Atrasado</option>
          <option value="parcial">Parcial</option>
        </Select>
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Forma de Recebimento:</FilterLabel>
        <Input value={form.forma_recebimento || ""} onChange={(e) => setForm({ ...form, forma_recebimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Categoria:</FilterLabel>
        <Input value={form.categoria || ""} onChange={(e) => setForm({ ...form, categoria: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Centro de Custo:</FilterLabel>
        <Input value={form.centro_custo || ""} onChange={(e) => setForm({ ...form, centro_custo: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Desconto Concedido:</FilterLabel>
        <Input type="number" value={form.desconto || ""} onChange={(e) => setForm({ ...form, desconto: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Juros Aplicado:</FilterLabel>
        <Input type="number" value={form.juros || ""} onChange={(e) => setForm({ ...form, juros: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Observações:</FilterLabel>
        <TextArea value={form.observacoes || ""} onChange={(e) => setForm({ ...form, observacoes: e.target.value })} />
      </FilterGroup>
    </TabContent>

    <TabContent visible={tabAtiva === "anexos"}>
      {/* Área para upload de anexos */}
    </TabContent>

    <TabContent visible={tabAtiva === "comunicacoes"}>
      {/* Área para mensagens, históricos ou logs */}
    </TabContent>

    
<TabContent visible={tabAtiva === "cliente"}>
  <FilterGroup>
    <FilterLabel>Nome/Razão Social:</FilterLabel>
    <Input value={form.cliente_nome || ""} onChange={(e) => setForm({ ...form, cliente_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF/CNPJ:</FilterLabel>
    <Input value={form.cliente_cnpj || ""} onChange={(e) => setForm({ ...form, cliente_cnpj: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Telefone:</FilterLabel>
    <Input value={form.cliente_telefone || ""} onChange={(e) => setForm({ ...form, cliente_telefone: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Email:</FilterLabel>
    <Input value={form.cliente_email || ""} onChange={(e) => setForm({ ...form, cliente_email: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo:</FilterLabel>
    <Select value={form.cliente_tipo || "pj"} onChange={(e) => setForm({ ...form, cliente_tipo: e.target.value })}>
      <option value="pj">Pessoa Jurídica</option>
      <option value="pf">Pessoa Física</option>
    </Select>
  </FilterGroup>
</TabContent>



<TabContent visible={tabAtiva === "cliente"}>
  <FilterGroup>
    
<FilterGroup>
  <FilterLabel>Tipo de Cliente:</FilterLabel>
  <Select value={form.cliente_tipo || "pj"} onChange={(e) => setForm({ ...form, cliente_tipo: e.target.value })}>
    <option value="pj">Pessoa Jurídica</option>
    <option value="pf">Pessoa Física</option>
  </Select>
</FilterGroup>


  <FilterLabel>Nome/Razão Social:</FilterLabel>
    <Input value={form.cliente_nome || ""} onChange={(e) => setForm({ ...form, cliente_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF/CNPJ:</FilterLabel>
    <Input value={form.cliente_cnpj || ""} onChange={(e) => setForm({ ...form, cliente_cnpj: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Telefone:</FilterLabel>
    <Input value={form.cliente_telefone || ""} onChange={(e) => setForm({ ...form, cliente_telefone: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Email:</FilterLabel>
    <Input value={form.cliente_email || ""} onChange={(e) => setForm({ ...form, cliente_email: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo:</FilterLabel>
    <Select value={form.cliente_tipo || "pj"} onChange={(e) => setForm({ ...form, cliente_tipo: e.target.value })}>
      <option value="pj">Pessoa Jurídica</option>
      <option value="pf">Pessoa Física</option>
    </Select>
  </FilterGroup>
</TabContent>


<ModalActions>
      <ButtonCancelar onClick={fecharModal}>Cancelar</ButtonCancelar>
      <ButtonSalvar onClick={salvarRecebimento}>Salvar</ButtonSalvar>
    </ModalActions>
  </ModalContent>
</ModalOverlay>

        )}

        {/* Modal de Confirmação de Exclusão */}
        {confirmarExclusao && (
          
<ModalOverlay>
  <ModalContent>
    <ModalTitle>{editando ? "Editar Recebimento" : "Novo Recebimento"}</ModalTitle>

    <TabsContainer>
      <Tab active={tabAtiva === "detalhes"} onClick={() => setTabAtiva("detalhes")}>Detalhes</Tab>
      <Tab active={tabAtiva === "anexos"} onClick={() => setTabAtiva("anexos")}>Anexos</Tab>
      <Tab active={tabAtiva === "comunicacoes"} onClick={() => setTabAtiva("comunicacoes")}>Comunicações</Tab>
    </TabsContainer>
<Tab active={tabAtiva === "cliente"} onClick={() => setTabAtiva("cliente")}>Cliente</Tab>

    <TabContent visible={tabAtiva === "detalhes"}>
      <FilterGroup>
        <FilterLabel>Descrição:</FilterLabel>
        <Input value={form.descricao || ""} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Valor:</FilterLabel>
        <Input type="number" value={form.valor || ""} onChange={(e) => setForm({ ...form, valor: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Vencimento:</FilterLabel>
        <Input type="date" value={form.vencimento || ""} onChange={(e) => setForm({ ...form, vencimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Recebimento:</FilterLabel>
        <Input type="date" value={form.data_recebimento || ""} onChange={(e) => setForm({ ...form, data_recebimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Status:</FilterLabel>
        <Select value={form.status || "pendente"} onChange={(e) => setForm({ ...form, status: e.target.value })}>
          <option value="pendente">Pendente</option>
          <option value="recebido">Recebido</option>
          <option value="atrasado">Atrasado</option>
          <option value="parcial">Parcial</option>
        </Select>
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Forma de Recebimento:</FilterLabel>
        <Input value={form.forma_recebimento || ""} onChange={(e) => setForm({ ...form, forma_recebimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Categoria:</FilterLabel>
        <Input value={form.categoria || ""} onChange={(e) => setForm({ ...form, categoria: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Centro de Custo:</FilterLabel>
        <Input value={form.centro_custo || ""} onChange={(e) => setForm({ ...form, centro_custo: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Desconto Concedido:</FilterLabel>
        <Input type="number" value={form.desconto || ""} onChange={(e) => setForm({ ...form, desconto: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Juros Aplicado:</FilterLabel>
        <Input type="number" value={form.juros || ""} onChange={(e) => setForm({ ...form, juros: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Observações:</FilterLabel>
        <TextArea value={form.observacoes || ""} onChange={(e) => setForm({ ...form, observacoes: e.target.value })} />
      </FilterGroup>
    </TabContent>

    <TabContent visible={tabAtiva === "anexos"}>
      {/* Área para upload de anexos */}
    </TabContent>

    <TabContent visible={tabAtiva === "comunicacoes"}>
      {/* Área para mensagens, históricos ou logs */}
    </TabContent>

    
<TabContent visible={tabAtiva === "cliente"}>
  <FilterGroup>
    <FilterLabel>Nome/Razão Social:</FilterLabel>
    <Input value={form.cliente_nome || ""} onChange={(e) => setForm({ ...form, cliente_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF/CNPJ:</FilterLabel>
    <Input value={form.cliente_cnpj || ""} onChange={(e) => setForm({ ...form, cliente_cnpj: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Telefone:</FilterLabel>
    <Input value={form.cliente_telefone || ""} onChange={(e) => setForm({ ...form, cliente_telefone: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Email:</FilterLabel>
    <Input value={form.cliente_email || ""} onChange={(e) => setForm({ ...form, cliente_email: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo:</FilterLabel>
    <Select value={form.cliente_tipo || "pj"} onChange={(e) => setForm({ ...form, cliente_tipo: e.target.value })}>
      <option value="pj">Pessoa Jurídica</option>
      <option value="pf">Pessoa Física</option>
    </Select>
  </FilterGroup>
</TabContent>



<TabContent visible={tabAtiva === "cliente"}>
  <FilterGroup>
    
<FilterGroup>
  <FilterLabel>Tipo de Cliente:</FilterLabel>
  <Select value={form.cliente_tipo || "pj"} onChange={(e) => setForm({ ...form, cliente_tipo: e.target.value })}>
    <option value="pj">Pessoa Jurídica</option>
    <option value="pf">Pessoa Física</option>
  </Select>
</FilterGroup>


  <FilterLabel>Nome/Razão Social:</FilterLabel>
    <Input value={form.cliente_nome || ""} onChange={(e) => setForm({ ...form, cliente_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF/CNPJ:</FilterLabel>
    <Input value={form.cliente_cnpj || ""} onChange={(e) => setForm({ ...form, cliente_cnpj: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Telefone:</FilterLabel>
    <Input value={form.cliente_telefone || ""} onChange={(e) => setForm({ ...form, cliente_telefone: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Email:</FilterLabel>
    <Input value={form.cliente_email || ""} onChange={(e) => setForm({ ...form, cliente_email: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo:</FilterLabel>
    <Select value={form.cliente_tipo || "pj"} onChange={(e) => setForm({ ...form, cliente_tipo: e.target.value })}>
      <option value="pj">Pessoa Jurídica</option>
      <option value="pf">Pessoa Física</option>
    </Select>
  </FilterGroup>
</TabContent>


<ModalActions>
      <ButtonCancelar onClick={fecharModal}>Cancelar</ButtonCancelar>
      <ButtonSalvar onClick={salvarRecebimento}>Salvar</ButtonSalvar>
    </ModalActions>
  </ModalContent>
</ModalOverlay>

        )}

        {/* Modal de Detalhes da Conta */}
        {contaSelecionada && (
          
<ModalOverlay>
  <ModalContent>
    <ModalTitle>{editando ? "Editar Recebimento" : "Novo Recebimento"}</ModalTitle>

    <TabsContainer>
      <Tab active={tabAtiva === "detalhes"} onClick={() => setTabAtiva("detalhes")}>Detalhes</Tab>
      <Tab active={tabAtiva === "anexos"} onClick={() => setTabAtiva("anexos")}>Anexos</Tab>
      <Tab active={tabAtiva === "comunicacoes"} onClick={() => setTabAtiva("comunicacoes")}>Comunicações</Tab>
    </TabsContainer>
<Tab active={tabAtiva === "cliente"} onClick={() => setTabAtiva("cliente")}>Cliente</Tab>

    <TabContent visible={tabAtiva === "detalhes"}>
      <FilterGroup>
        <FilterLabel>Descrição:</FilterLabel>
        <Input value={form.descricao || ""} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Valor:</FilterLabel>
        <Input type="number" value={form.valor || ""} onChange={(e) => setForm({ ...form, valor: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Vencimento:</FilterLabel>
        <Input type="date" value={form.vencimento || ""} onChange={(e) => setForm({ ...form, vencimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Data de Recebimento:</FilterLabel>
        <Input type="date" value={form.data_recebimento || ""} onChange={(e) => setForm({ ...form, data_recebimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Status:</FilterLabel>
        <Select value={form.status || "pendente"} onChange={(e) => setForm({ ...form, status: e.target.value })}>
          <option value="pendente">Pendente</option>
          <option value="recebido">Recebido</option>
          <option value="atrasado">Atrasado</option>
          <option value="parcial">Parcial</option>
        </Select>
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Forma de Recebimento:</FilterLabel>
        <Input value={form.forma_recebimento || ""} onChange={(e) => setForm({ ...form, forma_recebimento: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Categoria:</FilterLabel>
        <Input value={form.categoria || ""} onChange={(e) => setForm({ ...form, categoria: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Centro de Custo:</FilterLabel>
        <Input value={form.centro_custo || ""} onChange={(e) => setForm({ ...form, centro_custo: e.target.value })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Desconto Concedido:</FilterLabel>
        <Input type="number" value={form.desconto || ""} onChange={(e) => setForm({ ...form, desconto: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Juros Aplicado:</FilterLabel>
        <Input type="number" value={form.juros || ""} onChange={(e) => setForm({ ...form, juros: parseFloat(e.target.value) })} />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Observações:</FilterLabel>
        <TextArea value={form.observacoes || ""} onChange={(e) => setForm({ ...form, observacoes: e.target.value })} />
      </FilterGroup>
    </TabContent>

    <TabContent visible={tabAtiva === "anexos"}>
      {/* Área para upload de anexos */}
    </TabContent>

    <TabContent visible={tabAtiva === "comunicacoes"}>
      {/* Área para mensagens, históricos ou logs */}
    </TabContent>

    
<TabContent visible={tabAtiva === "cliente"}>
  <FilterGroup>
    <FilterLabel>Nome/Razão Social:</FilterLabel>
    <Input value={form.cliente_nome || ""} onChange={(e) => setForm({ ...form, cliente_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF/CNPJ:</FilterLabel>
    <Input value={form.cliente_cnpj || ""} onChange={(e) => setForm({ ...form, cliente_cnpj: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Telefone:</FilterLabel>
    <Input value={form.cliente_telefone || ""} onChange={(e) => setForm({ ...form, cliente_telefone: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Email:</FilterLabel>
    <Input value={form.cliente_email || ""} onChange={(e) => setForm({ ...form, cliente_email: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo:</FilterLabel>
    <Select value={form.cliente_tipo || "pj"} onChange={(e) => setForm({ ...form, cliente_tipo: e.target.value })}>
      <option value="pj">Pessoa Jurídica</option>
      <option value="pf">Pessoa Física</option>
    </Select>
  </FilterGroup>
</TabContent>



<TabContent visible={tabAtiva === "cliente"}>
  <FilterGroup>
    
<FilterGroup>
  <FilterLabel>Tipo de Cliente:</FilterLabel>
  <Select value={form.cliente_tipo || "pj"} onChange={(e) => setForm({ ...form, cliente_tipo: e.target.value })}>
    <option value="pj">Pessoa Jurídica</option>
    <option value="pf">Pessoa Física</option>
  </Select>
</FilterGroup>


  <FilterLabel>Nome/Razão Social:</FilterLabel>
    <Input value={form.cliente_nome || ""} onChange={(e) => setForm({ ...form, cliente_nome: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>CPF/CNPJ:</FilterLabel>
    <Input value={form.cliente_cnpj || ""} onChange={(e) => setForm({ ...form, cliente_cnpj: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Telefone:</FilterLabel>
    <Input value={form.cliente_telefone || ""} onChange={(e) => setForm({ ...form, cliente_telefone: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Email:</FilterLabel>
    <Input value={form.cliente_email || ""} onChange={(e) => setForm({ ...form, cliente_email: e.target.value })} />
  </FilterGroup>

  <FilterGroup>
    <FilterLabel>Tipo:</FilterLabel>
    <Select value={form.cliente_tipo || "pj"} onChange={(e) => setForm({ ...form, cliente_tipo: e.target.value })}>
      <option value="pj">Pessoa Jurídica</option>
      <option value="pf">Pessoa Física</option>
    </Select>
  </FilterGroup>
</TabContent>


<ModalActions>
      <ButtonCancelar onClick={fecharModal}>Cancelar</ButtonCancelar>
      <ButtonSalvar onClick={salvarRecebimento}>Salvar</ButtonSalvar>
    </ModalActions>
  </ModalContent>
</ModalOverlay>

        )}
      </Container>
      <Footer />
    </>
  );
}